module.exports = __webpack_public_path__ + "static/media/no-data.9b2850d7.svg";